// extracted by mini-css-extract-plugin
module.exports = {"input":"PricesPageSlider_input__1S4Ru"};